import React, { useContext,useEffect, useRef, useState } from "react";
import search from "../../assets/img/sreach---icon.svg";
import userpls from "../../assets/img/user-plus.svg";
import "../../assets/css/top-comm.css";
import profileimg from "../../assets/img/profile/profile-img.svg";
import { FollowOrganizationContext } from "../../config/FollowOrganizationContext";
import { API } from "../../services/api";
import { getOrganizations,followOrganization,unfollowOrganization,getOrganizationSearch} from "../../services/apiOragnizations";
import Unfollowpopup from "./popup/Unfollowpopup";
const TopOrganizations = () => {
  const { fetchAllOragnizations } = useContext(FollowOrganizationContext);
 const [followorganizations,setOrganization] =useState([]);
 const [followedOrgIds, setFollowedOrgIds] = useState(new Set());
 const[isLeaveOrganization,SetLeaveOragnization] = useState(false);
 const[organizationName,setOrganizationName] =useState("");
 const[organizationId,setOrganizationId] =useState("");
 const storedCommunityId = localStorage.getItem("FollowcommunityId");
  let searchkey='';
/* For Search */
   const[searchOrganizations,setSearchOrganizations]=useState([]);
  const [organizationValue, setorganizationValue] = useState('');
  const [organiationSearchSelected, setSearchOrganizationSelected] = useState(false);
  const[searchorganizationId,setSearchOrganizationId] = useState('');
  useEffect(()=>{
       if (organizationValue !== '') {
        listOragnizations(organizationValue)
      }
    },[organizationValue])
     useEffect(() => {
      if(searchorganizationId){
          // List that Organization from the array of FollowingOrganizations 
        const filteredOrgs = followorganizations.filter(org => org._id === searchorganizationId);
         setOrganization(filteredOrgs);
       
      }
    
    //fetchOrganizations(organizationValue);
   
      }, [searchorganizationId])
    
  /* End For Search */

  const userData = JSON.parse(localStorage.getItem('userData'));
  
    useEffect(()=>{
     fetchOrganizations(searchkey);
    },[])
  const fetchOrganizations=async(searchkey)=>{
     const listOrganizations = await getOrganizations({communityid:storedCommunityId,userid:userData._id,searchkey:searchkey,offset:0,limit:255});
     if(listOrganizations.organizations.length>0){
       setOrganization(listOrganizations.organizations||[]);
        // Initialize followedOrgIds with current follows
      const followedIds = new Set();
      listOrganizations.organizations.forEach(org => {
       
         if(org.following.length > 0)
            followedIds.add(org._id);
     
      });
      setFollowedOrgIds(followedIds);
      
      }
  }
  const followoOrganization=async(organizationId)=>{
    let follow_org = await followOrganization({organizationid:organizationId,userid:userData._id});
    if(follow_org.status === true){
        setFollowedOrgIds(prev => new Set(prev).add(organizationId));
        await fetchAllOragnizations({ userid: userData._id });
    }
    
  }
  const listOragnizations=async(organizationValue)=>{
       let myOrganizations = await getOrganizationSearch({"communityid":storedCommunityId,searchkey:organizationValue})
        setSearchOrganizations(myOrganizations.organizations ||[]);
  }
  const removefollowOrganization =async(organizationId,organizationName)=>{
      SetLeaveOragnization(true);
      setOrganizationName(organizationName);
      setOrganizationId(organizationId);
    
     
  }
  const LeaveOrganization =async(organizationId)=>{
     const leaveOrganization = await unfollowOrganization({organizationid:organizationId,userid:userData._id});
     if(leaveOrganization.status === true){
      SetLeaveOragnization(false); 
       setFollowedOrgIds(prev => {
      const newSet = new Set(prev);
      newSet.delete(organizationId); // Remove the organization ID
      return newSet;
    });
      await fetchAllOragnizations({ userid: userData._id });
     }
     
  }
  return (
    <div>
      <div class="">
        <div class="row">
          <div className="hd-breadcums">
              <h3 className="main-heading">Organizations</h3>
          </div>
        </div>
        <div class="">
          <div class="row">
          
            <div class="col-lg-4 my-2 ">
            <form className=" search-section  position-relative ">
                          <div class="d-flex ">
                            <div class=" search-box search-wrapper  d-flex align-items-center px-2 gap-2">
                              <span className="mobil-view-class border-end-0 ">
                                <img src={search} alt="search--Logo" className="search-logo-header mob-view-class pagess" />
                              </span>
                              <input type="text" name="communitySearch" class=" form-control border-start-0 search-inputs search-inside-color" placeholder="Search here"
                               id="exampleFormControlInput1"
                                    value={organizationValue}
                                    onChange={(e) => {
                                      e.preventDefault();
                                      setorganizationValue(e.target.value);
                                      setSearchOrganizationSelected(e.target.value !== ''); // Only show dropdown if there's text
                                      if (e.target.value === '') {
                                        setSearchOrganizationId(''); // Clear search ID when input is cleared
                                        fetchOrganizations(''); // Fetch all organizations
                                      }
                                     
                                    }}/>
                            </div>
                           
                          </div>
                          
                              {(searchOrganizations.length > 0) && organiationSearchSelected && (
                                <div className="col-lg-4 my-2 ">
                                <ul className="drop-div-join list-group mt-1 responsive-dropdown">
                                  {searchOrganizations.map((item, index) => (
                                    <li key={index} className="list-group-item d-flex align-items-center">
                                      <input
                                        type="radio"
                                        name="communityOption"
                                        id={`option-${index}`}
                                        value={item._id}
                                        checked={organizationValue === item.firstName}
                                         onChange={(e) => {
                                          e.preventDefault();
                                          setorganizationValue(item.firstName);
                                           setSearchOrganizationId(item._id);
                                          setSearchOrganizationSelected(false);// Hide dropdown after selection
                                        }}
                                        className="form-check-input me-2"
                                      />
                                      <label htmlFor={`option-${index}`} className="form-check-label w-100 mb-0">
                                        {item.firstName}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                                </div>
                              )}
                </form>
            </div>

            <div class="row w-100">
              {
                followorganizations.map((organizations)=>(
                    <div className="col-lg-4 col-md-6 mt-3 mb-3" >
              <div className="community-card d-flex justify-content-between align-items-center mb-2 ">
                <div className="d-flex align-items-center gap-2">
                  <img src={organizations?.profileImage?.url ? API.uploadFilePath + organizations?.profileImage?.url : profileimg} alt="Avatar" className="community-img" />
                  <span className="community-name-join text-truncate">
                    {organizations.firstName}</span>
                </div>
                <div className="d-flex align-items-center ">

                  {followedOrgIds.has(organizations._id)  ? (
                    <>
                    <button className="btn join-btn-comms d-flex align-items-center gap-1  py-1" >
                     Following
                      <button className="btn dots-btn"  onClick={() => removefollowOrganization(organizations._id,organizations.firstName)}>&#8942;</button>
                      </button>
                    </>
                    
                  ) : (
                    <>
                     <button className="btn join-btn-comms d-flex align-items-center gap-1  py-1" onClick={() => followoOrganization(organizations._id)}>
                      <img src={userpls} alt="Join" className="join-icon" />
                      Follow
                      </button>
                    </>
                  )}
                  
               
                 
                </div>
              </div>
            </div>


                ))
              }
          

          </div>


           
          </div>
        </div>
      </div>
   {
        isLeaveOrganization && (
         <Unfollowpopup  isConfirm={isLeaveOrganization}  CancelPopup={() => { 
                  SetLeaveOragnization(false);
                }} organizationName={organizationName} organizationId={organizationId} LeaveOrganization={LeaveOrganization}></Unfollowpopup>
      )}


        
    </div>

  );
};
export default TopOrganizations;